import classNames from 'classnames';
import React from 'react';

import styles from './../../../ricos-common-plugins/gap-spacer/gap-spacer-component/gap-spacer-styles-scss.js';

type GapSpacerProps = {
  collapsed?: boolean;
  betweenFloated?: boolean;
  needsTopMargin?: boolean;
};

export const GapSpacer: React.FC<GapSpacerProps> = ({
  collapsed,
  betweenFloated,
  needsTopMargin,
}) => {
  return (
    <div
      data-hook="gap-spacer"
      className={classNames(styles.gapSpacerViewer, {
        [styles.collapsed]: collapsed,
        [styles.betweenFloated]: betweenFloated,
        [styles.withTopMargin]: needsTopMargin,
      })}
    />
  );
};
